import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import { empresa, rest } from '@/config';

const endpoint = rest.endpoint;

import Modalidades from './modalidades';

let finalidade = 'aluguel';
let modalidade = 'residencial';
if (/comprar$/igm.test(location.pathname)) {
    finalidade = 'venda';
    modalidade = 'prontos';
}

export const state = {
    localidade: null,
    tipos_ids: [],
    finalidade,
    modalidade,
    cidades: {
        aluguel: [],
        venda: []
    },
    suggestions: {
        aluguel: {
            residencial: [],
            comercial: []
        },
        venda: {
            prontos: [],
            'lancamentos': []
        },
    },
    tipos: {
        aluguel: {
            comercial: [],
            residencial: []
        },
        venda: {
            prontos: [],
            'lancamentos': []
        }
    },
    caracteristicas: {
        aluguel: [],
        venda: []
    }
};
export const mutations = {
    setSuggestions(state, { finalidade, modalidade, suggestions }) {
        state.suggestions[finalidade][modalidade] = suggestions;
    },
    setTipos(state, { finalidade, modalidade, tipos }) {
        state.tipos[finalidade][modalidade] = tipos;
    },
    setCaracteristicas(state, { finalidade, caracteristicas }) {
        state.caracteristicas[finalidade] = caracteristicas;
    },
    setLocalidade(state, localidade) {

        state.localidade = localidade;
    },
    setTiposIds(state, tipos_ids = []) {
        state.tipos_ids = [...tipos_ids];
    },
    setCidades(state, {finalidade, cidades}) {
        state.cidades[finalidade] = cidades;
    }
};
export const actions = {
    setLocation({ commit }, localidade) {
        commit('setLocalidade', localidade);
    },
    setTiposIds({ commit }, tipos_ids) {
        commit('setTiposIds', tipos_ids);
    },
    async loadSuggestions({ commit, state }) {
        let finalidades = ['aluguel', 'venda'];
        //let modalidades = ['comercial', 'residencial'];
        let promises = [];
        finalidades.forEach(finalidade => {
            let modalidades = Modalidades[finalidade].map(modalidade => modalidade.id);
            modalidades.forEach(modalidade => {
                if (state.suggestions[finalidade][modalidade].length != 0) {
                    return;
                }
                let url_modalidade = modalidade;
                if (modalidade == 'lancamentos') {
                    //url_modalidade = 'lancamentos-vila-rica';
                }
                promises.push(fetch(`${endpoint}/${finalidade}/${url_modalidade}/sugestions.json?t=${Date.now()}`)
                    .then(resp => resp.json())
                    .then(suggestions => {
                        commit('setSuggestions', {
                            finalidade,
                            modalidade,
                            suggestions
                        })
                    })
                    .catch(console.error)
                );
            });
        });
        await Promise.all(promises);
    },
    async loadTipos({ commit, state }) {
        let finalidades = ['aluguel', 'venda'];

        //let modalidades = ['comercial', 'residencial'];
        let promises = [];
        finalidades.forEach(finalidade => {
            promises.push(fetch(`${endpoint}/${finalidade}/tipos.json?t=${Date.now()}`)
                .then(resp => resp.json())
                .then(tipos => {
                    let modalidades = Modalidades[finalidade].map(modalidade => modalidade.id);
                    modalidades.forEach(modalidade => {
                        //modalidade = modalidade.replace(/(-vila-rica|-sao-luiz)$/igm,'');
                        commit('setTipos', {
                            finalidade,
                            modalidade,
                            tipos: Object.values(tipos[modalidade])
                        });
                    });
                })
            );
        });
        await Promise.all(promises);
    },
    async loadCaracteristicas({ commit, state }) {
        let finalidades = ['aluguel', 'venda'];
        let promises = [];
        finalidades.forEach(finalidade => {
            if (state.caracteristicas[finalidade].length != 0) {
                return;
            }
            promises.push(fetch(`${endpoint}/${finalidade}/caracteristicas.json?t=${Date.now()}`)
                .then(resp => resp.json())
                .then(caracteristicas => {
                    if (finalidade == 'aluguel') {
                        return caracteristicas[empresa.slug]
                    }
                    return caracteristicas;
                })
                .then(caracteristicas => {
                    commit('setCaracteristicas', {
                        finalidade,
                        caracteristicas
                    })
                })
            );
        });
        await Promise.all(promises);
    },
    async loadCidades({ commit }, state) {
        let finalidades = ['aluguel','venda'];
        let promises = [];
        finalidades.forEach(finalidade => {
            promises.push(
                fetch(`${endpoint}/${finalidade}/cidades.json?t=${Date.now()}`)
                    .then(resp => resp.json())
                    .then(cidades => {
                        commit('setCidades', { finalidade, cidades});
                    })
            )
        })
    },
    async load({ dispatch }) {
        dispatch('loadSuggestions');
        dispatch('loadTipos');
        dispatch('loadCaracteristicas');
        dispatch('loadCidades');
    }
};
export const getters = {};
export const modules = {};
export const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules
});
export default store;

store.dispatch('load');
